import { MediaMatch } from '@lamimed/pantheon';
import Image, { StaticImageData } from 'next/legacy/image';

import * as S from './styles';

type FloatCardsWrapperProps = React.PropsWithChildren<{
  image: StaticImageData;
  reverse?: boolean;
  id?: string;
}>;

export const FloatCardsWrapper: React.FC<
  React.PropsWithChildren<FloatCardsWrapperProps>
> = ({ children, image, reverse, id }) => {
  return (
    <S.FloatCardsWrapperContainer>
      <S.CardsWrapper>
        <MediaMatch greaterThan="tablet">
          <S.ImageWrapper reverse={reverse}>
            <Image
              src={image}
              layout="fill"
              objectFit="cover"
              objectPosition="top left"
              quality={100}
              placeholder="blur"
            />
          </S.ImageWrapper>
        </MediaMatch>

        <S.ContentWrapper id={id} reverse={reverse}>
          {children}
        </S.ContentWrapper>
      </S.CardsWrapper>
    </S.FloatCardsWrapperContainer>
  );
};
